import axios from 'axios';

const apiTaskSolutions = {
    get(idToken) {
        return axios.get(`${process.env.VUE_APP_APIURL}/task-solutions`, {
            headers: {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            }
        });
    }
};
export default apiTaskSolutions;
